import { useAuth } from '@/hooks/useAuth'
import { OrganizationProvider, useOrganization } from '@/hooks/useOrganization'
import OrganizationSelector from '@/components/OrganizationSelector'
import { useEffect } from 'react'
import Header from '@/components/Header'
import Sidebar from '@/components/Sidebar'
import FullScreenLoader from '@/components/FullScreenLoader'
import { Outlet, useNavigate } from 'react-router-dom'

export default function AuthenticatedLayout() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login')
    }
  }, [user, loading, navigate])

  if (loading) {
    return <FullScreenLoader message="Loading session..." />
  }

  if (!user) {
    // Optionally render nothing or a spinner while redirecting
    return null
  }

  return (
    <OrganizationProvider>
      <OrgLayoutOrSelector />
    </OrganizationProvider>
  )
}

function OrgLayoutOrSelector() {
  const { organization, loading } = useOrganization()
  if (loading) return <FullScreenLoader message="Loading organization..." />
  if (!organization) return <OrganizationSelector />
  return (
    <div className="flex min-h-screen bg-muted/10">
      <Sidebar />
      <div className="flex-1 flex flex-col min-h-screen">
        <Header />
        <main className="flex-1 container mx-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}